import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  getSharedEnv: function getSharedEnv(_ref) {
    var payload = _ref.payload;
    return payload;
  },
  tracking: function tracking(_ref2) {
    var payload = _ref2.payload;
    return payload.tracking;
  },
  oauth: function oauth(_ref3) {
    var payload = _ref3.payload;
    return payload.oauth;
  }
};